<div>
  <br />
  <p class="retrofit-task-item-title">
    <span>
      Invoice for receiving a Bid
    </span>
  </p>
  <div>Were you required to pay upfront for a bid/estimate?</div>
  <small>CRMP will cover the cost of a single estimate under your grant.</small>

  <form [formGroup]="formBidInvoiceInfo">
    <div style="margin-top:10px;margin-bottom:10px;">
      <mat-radio-group
        id="bidInvoiceNeeded"
        name="bidInvoiceNeeded"
        formControlName="bidInvoiceNeeded"
        (change)="onChangeEventBidInvoice($event)"
        class="retrofit-task-radio-group horizontal-radio">
        <mat-radio-button value="yes">
          Yes
        </mat-radio-button>
        <mat-radio-button value="no">
          No
        </mat-radio-button>
      </mat-radio-group>
      @if (this.loading && !this.bidInvoiceNeeded) {
        <div class="w-400">
          <br />
          Loading...
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
    @if (bidInvoiceNeeded == true) {
      <div>
        <div class="retrofit-form-text">
          <div [innerHTML]="textBidInvoiceFileIntroSgHelpText"></div>
        </div>
        <br />
        <ebb-portal-file-list
          [context]="'PreRetrofit'"
          [title]=""
          [application]="applicationData"
          [task]="taskSgFiltered"
          [disable]="sgBidSubmitted"
          (emitFileUploadEvent)="onEmitFileUploadEvent($event)"
          >
        </ebb-portal-file-list>
        @if (this.loading) {
          <div class="w-400">
            Loading...
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        }
        <br />
        <div class="retrofit-form-text">
          <div [innerHTML]="textBidInvliceCostIntroSgHelpText"></div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-12">
            <mat-form-field
              appearance="outline"
              style="min-width: 250px;">
              <mat-label>Cost for one bid/estimate</mat-label>
              <input matInput currencyMask autocomplete="off" focus="false"
                min="1.00"
                required
                id="bidInvoiceCost"
                name="bidInvoiceCost"
                formControlName="bidInvoiceCost">
                @if (formBidInvoiceInfo.get('bidInvoiceCost').hasError('required')) {
                  <mat-error>
                    Bid/estimate cost is required
                  </mat-error>
                }
                @if (formBidInvoiceInfo.get('bidInvoiceCost').hasError('min')) {
                  <mat-error>
                    Bid/estimate cost must be greater than $1.00.
                  </mat-error>
                }
                @if (formBidInvoiceInfo.get('bidInvoiceCost').hasError('max')) {
                  <mat-error>
                    Bid/estimate cost must not be greater than $250.
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-md-12">
              <button
                mat-raised-button color="primary"
                type="button"
                (click)="onClickSaveBidInvoiceInfo()"
                [disabled]="checkBidInvoiceFormLock()">
                SAVE & SUBMIT
              </button>
            </div>
          </div>
        </div>
      }
    </form>
  </div>